export const initial = {
  currentPage: 1,
  itemsPerPage: 10,
  isFetching: false,
  showRefreshModal: false,
  refreshDate: '',
  nextPaymentCycle: '',
  periods: [],
  items: [],
  sort: {
    key: 'date',
    order: -1,
  },
  filter: {
    period: '',
    publisherName: '',
    publisherEmail: '',
    publisherId: '',
    publisherExternalId: '',
    status: '',
    paymentMethod: '',
    paypalEmail: '',
  },
  processing: false,
  uploading: false,
};



/** WEBPACK FOOTER **
 ** ./js/redux/state/payments.state.js
 **/